import axios from "../../utility/customAxios";
import {
  Investigation,
  InvestigationComment,
  CreateInvestigationRequest,
  UpdateInvestigationRequest,
  ListInvestigationsRequest,
  ListInvestigationsResponse,
  CreateInvestigationCommentRequest,
  UpdateInvestigationCommentRequest,
  ListInvestigationCommentsResponse,
} from "../../types/investigation";

const API_BASE = "/api/v1";

// Investigation APIs
export const createInvestigation = async (
  request: CreateInvestigationRequest
): Promise<Investigation> => {
  const response = await axios.post(`${API_BASE}/investigation`, request);
  return response.data;
};

export const getInvestigation = async (uuid: string): Promise<Investigation> => {
  const response = await axios.get(`${API_BASE}/investigation`, {
    params: { uuid },
  });
  return response.data;
};

export const updateInvestigation = async (
  uuid: string,
  request: UpdateInvestigationRequest
): Promise<void> => {
  await axios.put(`${API_BASE}/investigation`, request, {
    params: { uuid },
  });
};

export const deleteInvestigation = async (uuid: string): Promise<void> => {
  await axios.delete(`${API_BASE}/investigation`, {
    params: { uuid },
  });
};

export const listInvestigations = async (
  request: ListInvestigationsRequest
): Promise<ListInvestigationsResponse> => {
  const response = await axios.post(`${API_BASE}/investigations/list`, request);
  return response.data;
};

export const resolveInvestigation = async (uuid: string): Promise<void> => {
  await axios.put(`${API_BASE}/investigation/resolve`, null, {
    params: { uuid },
  });
};

export const unresolveInvestigation = async (uuid: string): Promise<void> => {
  await axios.put(`${API_BASE}/investigation/unresolve`, null, {
    params: { uuid },
  });
};

// Investigation Comment APIs
export const createInvestigationComment = async (
  investigationUuid: string,
  request: CreateInvestigationCommentRequest
): Promise<InvestigationComment> => {
  const response = await axios.post(`${API_BASE}/investigation/comment`, request, {
    params: { investigationUuid },
  });
  return response.data;
};

export const updateInvestigationComment = async (
  uuid: string,
  request: UpdateInvestigationCommentRequest
): Promise<void> => {
  await axios.put(`${API_BASE}/investigation/comment`, request, {
    params: { uuid },
  });
};

export const deleteInvestigationComment = async (uuid: string): Promise<void> => {
  await axios.delete(`${API_BASE}/investigation/comment`, {
    params: { uuid },
  });
};

export const listInvestigationComments = async (
  investigationUuid: string
): Promise<ListInvestigationCommentsResponse> => {
  const response = await axios.get(`${API_BASE}/investigation/comments`, {
    params: { investigationUuid },
  });
  return response.data;
};